import TextField, { TextFieldProps } from '../TextField/TextField';

const TimeField = ({ value, type, ...props }: TextFieldProps) => {
  return <TextField type="time" value={value || ''} {...props} />;
};

export default TimeField;
